import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-html',
    templateUrl: 'html.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class HtmlComponent {
    constructor() {

    }
}
